import { Controller } from '@hotwired/stimulus';
import { useEventListener } from 'stimulus-library/dist';

export default class extends Controller {
  static targets = ['iconInput', 'iconFamilyInput', 'iconPreview'];

  connect() {
    useEventListener(this, this.iconInputTarget, ['input', 'change'], this.refreshPreview, { debounce: 500 });
    useEventListener(this, this.iconFamilyInputTarget, ['input', 'change'], this.refreshPreview, { debounce: 500 });
    this.refreshPreview();
  }

  refreshPreview() {
    this.iconPreviewTarget.innerHTML = `<i class="${this.iconFamilyInputTarget.value} ${this.iconInputTarget.value} fa-lg"></i>`;
  }
}
